<!-- m3u8VideoPreview -->
<template>
    <div class="m3u8VideoPreview" v-loading="videoLoading" :style="StyleMessage">
      <video :id="'m3u8Video' + videoid" :muted="muted" :style="StyleMessage"></video>
      <i @click="muted = !muted" :class="['iconfont', muted ? 'icon-volume_off' : 'icon-volume-up']"></i>
    </div>
</template>

<script>
import videojs from 'video.js'
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    videoMessage: {
      type: Object,
      default: () => {}
    },
    StyleMessage: {
      type: Object,
      default: () => {
        return {
          width: '400px',
          height: '228px'
        }
      }
    }
  },
  data () {
    return {
      // 声音
      muted: true,
      // 视频实例
      videoPlayer: null,
      // 加载
      videoLoading: true,
      // 标签id
      videoid: ''
    }
  },
  created () {
    this.videoid = Outil.return32Str()
  },
  mounted () {
    this.$nextTick(() => {
      this.initVideo()
    })
  },
  methods: {
    initVideo () {
      this.videoPlayer = videojs('m3u8Video' + this.videoid, {
        // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: false,
        autoplay: true,
        preload: 'auto',
        sources: [{ src: this.videoMessage.filePath, type: 'application/x-mpegURL' }]
      }, () => {
        this.videoPlayer.on('error', () => {
          this.videoPlayer.errorDisplay.close()
          this.loadError = true
        })
        this.videoPlayer.on('timeupdate', () => {
          this.videoLoading = false
        })
        this.videoPlayer.on('waiting', () => {
          // 延迟显示loading，防止 timeupdate(300ms左右一次)函数 在执行了waiting后还触发一次
          setTimeout(() => {
            this.videoLoading = true
          }, 400)
        })
      })
    }
  },
  beforeDestroy () {
    this.videoPlayer = null
  }
}
</script>

<style scoped lang="less">
.m3u8VideoPreview{
  position: relative;
  overflow: hidden;
  i{
    position: absolute;
    bottom: 10px;
    right: 20px;
  }
}

</style>
